import { render, staticRenderFns } from "./PaymentAttributeDetail.vue?vue&type=template&id=e96fd36e"
import script from "../../controllers/payment_attribute/payment-attribute-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_attribute/payment-attribute-detail.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeDetail.vue?vue&type=style&index=0&id=e96fd36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports